import { getFirstDeviceSelectionCategory } from './deviceSelectionCategoryUtilsCoCo.js';
import type { DeviceSelectionProductTypeCoCo } from './deviceListTabsUtilsCoCo.js';
import type { DeviceSelectionCategoryCoCo } from './deviceSelectionCategoryUtilsCoCo.js';

export { DEVICE_SELECTION_PRODUCT_TYPES as DEFAULT_AVAILABLE_PRODUCT_TYPES } from './deviceListTabsUtilsCoCo.js';

export const DESCRIPTION_MAX_LENGTH = 255;

export const DeviceSelectionFormFieldCoCo = {
  NAME: 'name',
  DESCRIPTION: 'description',
  PRODUCT_TYPE: 'productType',
  CATEGORY: 'category',
  SELECTED_DEVICE_IDS: 'selectedDeviceIds',
} as const;

export interface DeviceSelectionFormValuesCoCo {
  [DeviceSelectionFormFieldCoCo.NAME]: string;
  [DeviceSelectionFormFieldCoCo.DESCRIPTION]: string;
  [DeviceSelectionFormFieldCoCo.PRODUCT_TYPE]?: DeviceSelectionProductTypeCoCo;
  [DeviceSelectionFormFieldCoCo.CATEGORY]?: DeviceSelectionCategoryCoCo;
  [DeviceSelectionFormFieldCoCo.SELECTED_DEVICE_IDS]: string[];
}

export type DeviceSelectionSummaryStateCoCo = DeviceSelectionFormValuesCoCo;

export const getDeviceSelectionFormDefaultValues = (
  productType?: DeviceSelectionProductTypeCoCo
): DeviceSelectionFormValuesCoCo => ({
  [DeviceSelectionFormFieldCoCo.NAME]: '',
  [DeviceSelectionFormFieldCoCo.DESCRIPTION]: '',
  [DeviceSelectionFormFieldCoCo.PRODUCT_TYPE]: productType,
  [DeviceSelectionFormFieldCoCo.CATEGORY]: getFirstDeviceSelectionCategory(productType),
  [DeviceSelectionFormFieldCoCo.SELECTED_DEVICE_IDS]: [],
});
